// Экземпляр роутера приложения.

import { createRouter } from '@tanstack/react-router';

import { queryClient } from '@/shared/api';

import { NotFoundPage } from './pages/NotFoundPage';
import { routeTree } from './routeTree';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  // Префетч по намерению (наведение/касание) — на моноблоке это экономит
  // ощутимые доли секунды между тапами.
  defaultPreload: 'intent',
  // Без этого роутер отдавал голое «Not Found» — текст без интерфейса, из которого
  // в оболочке на устройстве точки не выйти: адресной строки там нет.
  defaultNotFoundComponent: NotFoundPage,
});

// Регистрация типа роутера: даёт типобезопасные Link, useNavigate и search params.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
